//
//
//
//
//
//
//
//
//
//
//
//
//

import InfoList from '@/components/InfoList';
import EducationAdd from './EducationAdd';
import PersonalCard from '~/components/Card/PersonalCard';
import { sortByDate } from '@/utils';
import { educationStatusLabel } from '@/utils/filters';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Education',
  components: { InfoList, PersonalCard, EducationAdd },
  data() {
    return {
      dlgShow: false,
      editMode: false,
      currentItem: {},
    };
  },
  computed: {
    ...mapGetters('personal', ['resumeData']),
    dataForInfoList() {
      if (!this.resumeData.userEducationList) return [];
      let educationList = [].concat(this.resumeData.userEducationList);
      const list = educationList.map(item => {
        return {
          title: item.name,
          notes: [`${item.startDate || ''} ~ ${item.endDate || ''}`],
          list: [
            {
              contents: [
                item.department || '',
                item.status ? educationStatusLabel(item.status) : '',
              ],
            },
          ],
          remark: item.remark || '',
        };
      });
      return list;
    },
  },
  methods: {
    ...mapActions('personal', ['setEducationList']),
    handleDeleteEducation(payload) {
      this.$api('userDeleteEducation', payload).then(() => {
        this.$message.success('刪除成功!');
        this.getEducationList();
      });
    },
    getEducationList() {
      this.$api('userGetEducationList').then(data => {
        this.setEducationList(sortByDate(data));
      });
    },
    openAdd() {
      this.currentItem = {};
      this.dlgShow = true;
      this.editMode = false;
    },
    openEdit(index) {
      this.currentItem = this.resumeData.userEducationList[index];
      this.dlgShow = true;
      this.editMode = true;
    },
    onDelete(index) {
      this.$confirm('是否刪除此學歷？', '提示', {
        type: 'warning',
      }).then(() => {
        const payload = {
          id: this.resumeData.userEducationList[index].id,
        };
        this.handleDeleteEducation(payload);
      });
    },
  },
};
